module.exports = __webpack_public_path__ + "img/shadow_rect_mask.7f84adb1.png";